<template>
  <div class="HomeCss">
    <vueHeader />
    <router-view />
    <FooterZx />
    <ZxPopbox />
    <vueFooter />
  </div>
</template>

<script>
import vueHeader from '@/components/Header.vue';
import FooterZx from '@/components/FooterZx.vue';
import ZxPopbox from '@/components/ZxPopbox.vue';
import vueFooter from '@/components/Footer.vue';

export default {
  name: 'PublicLayout',
  components: {
    vueHeader,
    FooterZx,
    ZxPopbox,
    vueFooter
  }
}
</script>
